webpackJsonp([118442821920679],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(14);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function List(props) {
	  var edges = props.edges,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "ul",
	      {
	        className: _style2.default.dynamic([["132031231", [theme.space.stack.m, theme.space.m, theme.space.xs, theme.font.size.s, theme.font.lineHeight.l]]])
	      },
	      edges.map(function (edge) {
	        var _edge$node = edge.node,
	            title = _edge$node.frontmatter.title,
	            slug = _edge$node.fields.slug;
	
	
	        return _react2.default.createElement(
	          "li",
	          { key: slug, className: _style2.default.dynamic([["132031231", [theme.space.stack.m, theme.space.m, theme.space.xs, theme.font.size.s, theme.font.lineHeight.l]]])
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: slug },
	            title
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "132031231",
	      css: ["ul.__jsx-style-dynamic-selector{margin:" + theme.space.stack.m + ";padding:" + theme.space.m + ";list-style:circle;}", "li.__jsx-style-dynamic-selector{padding:" + theme.space.xs + " 0;font-size:" + theme.font.size.s + ";line-height:" + theme.font.lineHeight.l + ";}"],
	      dynamic: [theme.space.stack.m, theme.space.m, theme.space.xs, theme.font.size.s, theme.font.lineHeight.l]
	    })
	  );
	};
	
	List.propTypes = {
	  edges: _propTypes2.default.array.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = List;
	module.exports = exports["default"];

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _List = __webpack_require__(185);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.guery = undefined;
	
	var _style = __webpack_require__(14);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _tag = __webpack_require__(141);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layouts = __webpack_require__(39);
	
	var _Article = __webpack_require__(73);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Headline = __webpack_require__(88);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _List = __webpack_require__(186);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Seo = __webpack_require__(65);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryPage = function CategoryPage(props) {
	  var _props$data = props.data,
	      posts = _props$data.posts.edges,
	      facebook = _props$data.site.siteMetadata.facebook;
	
	  // Create category list
	
	  var categories = {};
	  posts.forEach(function (edge) {
	    var category = edge.node.frontmatter.category;
	
	
	    if (category && category != null) {
	      if (!categories[category]) {
	        categories[category] = [];
	      }
	      categories[category].push(edge);
	    }
	  });
	
	  var categoryList = [];
	
	  for (var key in categories) {
	    categoryList.push([key, categories[key]]);
	  }
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _layouts.ThemeContext.Consumer,
	      null,
	      function (theme) {
	        return _react2.default.createElement(
	          _Article2.default,
	          { theme: theme },
	          _react2.default.createElement(
	            "header",
	            {
	              className: _style2.default.dynamic([["3401059523", [theme.color.brand.primary]]])
	            },
	            _react2.default.createElement(_Headline2.default, { title: "Posts by categories", theme: theme })
	          ),
	          categoryList.map(function (item) {
	            return _react2.default.createElement(
	              "section",
	              { key: item[0], className: _style2.default.dynamic([["3401059523", [theme.color.brand.primary]]])
	              },
	              _react2.default.createElement(
	                "h2",
	                {
	                  className: _style2.default.dynamic([["3401059523", [theme.color.brand.primary]]])
	                },
	                _react2.default.createElement(_tag2.default, null),
	                " ",
	                item[0]
	              ),
	              _react2.default.createElement(_List2.default, { edges: item[1], theme: theme })
	            );
	          }),
	          _react2.default.createElement(_style2.default, {
	            styleId: "3401059523",
	            css: ["h2.__jsx-style-dynamic-selector{margin:0 0 0.5em;}", "h2.__jsx-style-dynamic-selector svg{height:0.8em;fill:" + theme.color.brand.primary + ";}"],
	            dynamic: [theme.color.brand.primary]
	          })
	        );
	      }
	    ),
	    _react2.default.createElement(_Seo2.default, { facebook: facebook })
	  );
	};
	
	CategoryPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = CategoryPage;
	
	//eslint-disable-next-line no-undef
	
	var guery = exports.guery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-category-js-bbb34571e9395b2ce79b.js